<template>

  <!-- Quiz Subject Card -->
  <q-responsive
    :ratio="16/9"
    @click="$emit('click')"
    class="quiz-subject-card"
    :class="{'cursor-pointer': $listeners.click}">

    <div
      class="quiz-subject-card__hover">
    </div>

    <div
      class="quiz-subject-card__wrapper">

      <div
        class="quiz-subject-card__media">

        <img
          class="quiz-subject-card__image"
          :src="getFileUrl(value.miniature)"/>

        <img
          class="quiz-subject-card__image-hover"
          :src="getFileUrl(value.miniatureHover)"/>

      </div>

      <div
        class="quiz-subject-card__title">
        {{ value.title && value.title.ru || 'Без названия' }}
      </div>

      <img
        class="quiz-subject-card__button"
        src="/images/icons/fab-arrow-right.svg"/>

      <img
        class="quiz-subject-card__button_hover"
        src="/images/icons/fab-arrow-right-hover.svg"/>

    </div>

  </q-responsive>

</template>

<script>

  export default {
    name: 'quiz-subject-card',
    props: {
      value: {
        type: Object,
        default: () => {},
      },
    },
  };

</script>

<style lang="scss">

  $cls: quiz-subject-card;

  .quiz-subject-card {
    overflow: hidden;
    color: $font-color;
    border-radius: 1rem;
    background: #F5F5F7;
    transition: all .1s linear;

    &__hover {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      position: absolute;
      transition: all .1s linear;
      background: $brand-gradient;
    }

    &:hover {
      color: white;

      .#{$cls}__hover {
        opacity: 1;
      }

      .#{$cls}__button {
        opacity: 0;
      }

      .#{$cls}__button_hover {
        opacity: 1;
      }

      .#{$cls}__image {
        opacity: 0;
      }

      .#{$cls}__image-hover {
        opacity: 1;
      }
    }

    &__button,
    &__button_hover {
      left: 0;
      bottom: 0;
      width: 2.2rem;
      position: absolute;
      transition: opacity .2s linear;
    }

    &__button_hover {
      opacity: 0;
    }

    &__wrapper {
      top: $spacer-sm;
      left: $spacer-mm;
      right: $spacer-mm;
      bottom: $spacer-sm;
      position: absolute;
      width: auto !important;
      height: auto !important;
    }

    &__title {
      font-size: 1.4rem;
      font-weight: 500;

      @media (max-width: $breakpoint-xs) {
        font-size: 1.3rem;
      }

      @media (max-width: 330px) {
        font-size: 1.1rem;
      }
    }

    &__media {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      position: absolute;
    }

    &__image,
    &__image-hover {
      right: 0;
      bottom: 0;
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      transition: all .2s linear;

      @media (max-width: $breakpoint-xs) {
        max-height: 70%;
      }
    }

    &__image-hover {
      opacity: 0;
    }
  }

</style>
